import React, { memo } from 'react'
import styles from './ProductFormWrapper.module.scss'

type Props = {
    title: string,
    isValid: boolean,
    isLastStep?: boolean,
    isSubmitted: boolean,
    onNext: () => void,
    children: React.ReactNode
}

const ProductFormWrapper: React.FC<Props> = memo((props: Props) => {
    const { children, onNext, title, isValid, isLastStep, isSubmitted } = props

    const isDisabled = isSubmitted && !isValid

    return (
        <>
            <div className={styles.headerContainer}>
                <h2 className={styles.title}>{title}</h2>
                <button
                    disabled={isDisabled}
                    className={`standardButton ${styles.nextButton} ${isDisabled ? styles.disableButton : ''}` }
                    onClick={onNext}>
                    {isLastStep ? 'Submit' : 'Next'}
                    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.44665 6.00047L0.373576 1.92737C0.235109 1.78892 0.164276 1.61489 0.161076 1.40527C0.157859 1.19568 0.228692 1.01844 0.373576 0.873575C0.518442 0.728692 0.694075 0.65625 0.900475 0.65625C1.10688 0.65625 1.28251 0.728692 1.42738 0.873575L5.9216 5.3678C6.0152 5.46138 6.08123 5.5601 6.11968 5.66395C6.15814 5.76778 6.17738 5.87996 6.17738 6.00047C6.17738 6.12099 6.15814 6.23317 6.11968 6.337C6.08123 6.44085 6.0152 6.53957 5.9216 6.63315L1.42738 11.1274C1.28893 11.2658 1.11489 11.3367 0.905275 11.3399C0.695675 11.3431 0.518442 11.2723 0.373576 11.1274C0.228692 10.9825 0.15625 10.8069 0.15625 10.6005C0.15625 10.3941 0.228692 10.2184 0.373576 10.0736L4.44665 6.00047Z" fill="#F68B1E" />
                    </svg>
                </button>
            </div>
            {children}
        </>
    )
})

export default ProductFormWrapper